import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import reducer from "./store/reducer";
import { Provider } from "react-redux";
import { createStore } from "redux"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

localStorage.setItem('rcml-lang', localStorage.getItem('rcml-lang') || 'en')

const store = createStore(reducer);

const app = (
  <Provider store={store}>
    <GoogleReCaptchaProvider
      reCaptchaKey="6LfrKXYsAAAAADtTRop9N-uDaj5pcbN5-Yp3u5Qq"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
    <Router basename="/">
      <App />
    </Router>
    </GoogleReCaptchaProvider>
  </Provider>
);

ReactDOM.render(app, document.getElementById("root"));
